import React from 'react';
import { Box, ShimmerBox, Separator, Colors } from '@utex/ui-kit';
import { IconSideUserpic } from '../../../Icons';

interface Props {
  isBottomBorderVisible?: boolean;
}

export const Placeholder: React.FC<Props> = ({ isBottomBorderVisible }) => (
  <Box margin={[0, 18]}>
    <Box
      display="flex"
      flexDirection={{ all: 'column', phonablet: 'row' }}
      alignItems="center"
      marginBottom={19}
    >
      <IconSideUserpic width={{ all: 80, phonablet: 36 }} height={{ all: 80, phonablet: 36 }} />
      <ShimmerBox
        marginTop={{ all: 13, phonablet: 0 }}
        marginLeft={{ all: 0, phonablet: 15 }}
        width={{ all: 175, phonablet: 145 }}
        height={18}
      />
      <ShimmerBox display={{ phonablet: 'none' }} marginTop={6} width={125} height={12} />
    </Box>

    {isBottomBorderVisible && (
      <Box display={{ phonablet: 'none' }} marginTop={23} marginBottom={10}>
        <Separator margin={[0, 24]} color={Colors.ut.border5} />
      </Box>
    )}
  </Box>
);
